<template>
    <section class="gmp-section gmp-mb-l">

        <div class="two-column-tout two-column-tout--fullbleed">
            <div class="two-column-tout__side h-c-grid__col-l--order-2">
                <div class="two-column-tout__half-page two-column-tout__half-page--right">
                    <div class="two-column-tout__half-grid two-column-tout__half-grid--right">
                        <div class="two-column-tout__col two-column-tout__col--large">
                            <h3 class="h-c-headline h-c-headline--one">
                                了解更多特点
                            </h3>
                            <p class="h-u-mb-std two-column-tout__description">
                                深入了解该商品的市场需求、生产周期、质量控制等各个环节，从而提供更高质量的产品
                            </p>
                            <a  @click="toEnterprisePage('/market/goods/GOODS_Special','/market/goods/GOODS_Special')"   class="h-c-link h-c-link--internal gmp-link">
                                查看所有特点</a>
                        </div>

                    </div>

                </div>
            </div>
            <div class="two-column-tout__side h-c-grid__col-l--order-1">
                <div class="two-column-tout__image two-column-tout__image--left">
                    <picture>
                        <img src="@/assets/img/twobleed.png" alt="" class="gmp-no-grab " >
                    </picture>

                </div>
            </div>

        </div>


    </section>
</template>

<script>
    export default {
        name: "GOODS_two_column_fullbleed",


        methods:{
            toEnterprisePage(data, url) {
                this.$router.push(data)
                this.$('body').removeClass('h-is-showing-drawer');
                var lis = this.$('.h-c-header__drawer-nav-li-link');
                for (var i = 0; i < lis.length; i++) {
                    var toWhere = this.$(lis[i]).attr('to-where');
                    console.log("toWhere===" + toWhere);
                    if (toWhere === url) {
                        this.$(lis[i]).addClass('h-is-active');
                    } else {
                        this.$(lis[i]).removeClass('h-is-active')
                    }
                }
            },
        }
    }
</script>

<style lang="less">


</style>